var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"mainArea"},[_c('div',{on:{"click":_vm.goback}},[_vm._v("橙猩视点 > 详情")]),_c('div',{staticClass:"contentinfo"},[_c('keep-alive',[_c(_vm.currentTab,{tag:"component"})],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }